<template>
    <v-container class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 id="heading" class="text-left">Preset General Config</h1>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                         density="compact" variant="tonal">
                    <p v-for="error in errors">{{ error }}</p>
                </v-alert>
            </v-col>
        </v-row>


        <v-form v-model="formData.valid" class="pb-5 text-start" validate-on="input lazy"
                @submit.prevent="storeTemplate">
            <v-row>
                <v-col cols="6">
                    <v-switch v-model="formData['periodic_reboot_status']"
                              :rules="[vRules.required]"
                              color="primary"
                              density="compact"
                              label="Periodic Reboot Status"
                    />
                </v-col>
                <v-col cols="6">
                    <v-switch v-model="formData['lte_scan_status']"
                              :rules="[vRules.required]"
                              color="primary"
                              density="compact"
                              label="LTE Scan Status"
                    />
                </v-col>
                <v-col cols="6">
                    <v-switch v-model="formData['ble_scan_status']"
                              :rules="[vRules.required]"
                              color="primary"
                              density="compact"
                              label="BLE Scan Status"
                    />
                </v-col>
                <v-col cols="6">
                    <v-switch v-model="formData['wifi_scan_status']"
                              :rules="[vRules.required]"
                              color="primary"
                              density="compact"
                              label="Wifi Scan Status"
                    />
                </v-col>

                <v-col class="py-0" cols="12">
                    <v-text-field v-model="formData['label']"
                                  :rules="[vRules.required,vRules.maxLength(64)]"
                                  density="compact" label="Label"/>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['network_diagnostics_status']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  label="Network Diagnostic Status"
                                  type="number"
                    />
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['gateway_timeout_in_milli_seconds']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint=" Milliseconds"
                                  label="Gateway Timeout"
                                  type="number"/>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['movement_starts_alert_flag']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  label="Movement Start Alert Flag"
                                  type="number"/>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['network_registration_timeout_in_seconds']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Seconds"
                                  label="Network Registration Timeout"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['periodic_reboot_interval_seconds']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Minutes"
                                  label="Periodic Reboot Interval"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['server_acknowledgment_seconds']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Seconds"
                                  label="Server Acknowledgment"
                                  type="number"/>
                </v-col>


                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['network_diagnostics_period_seconds']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Seconds"
                                  label="Network Diagnostic Period"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['heartbeat_packet_seconds']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Seconds"
                                  label="Heartbeat Packet"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['movement_progress_alert_seconds']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Seconds"
                                  label="Movement Progress Alert"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['activity_threshold_x_axes']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  label="Activity Threshold X Axes"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['activity_threshold_y_axes']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  label="Activity Threshold Y Axes"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['activity_threshold_z_axes']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  label="Activity Threshold Z Axes"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['seconds_per_sample']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  label="Seconds per sample"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['minimum_activity_interrupts_needed_per_sample']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Per sample"
                                  label="Minimum activity interrupts needed"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['fifo_size']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  label="FIFO Size"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['fifo_movement_start_thresholds']"
                                  @blur="updateMovementFifoThreshold"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  label="FIFO movement starts thresholds"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['fifo_movement_continue_thresholds']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  label="FIFO movement continue thresholds"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['gps_minimum_accuracy_idle']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Idle"
                                  label="GPS minimum accuracy (Idle)"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['gps_minimum_accuracy_movement']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Movement"
                                  label="GPS minimum accuracy (Movement)"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['gps_fix_timeout_idle_seconds']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Idle in seconds"
                                  label="GPS fix timeout (Idle)"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['gps_fix_timeout_movement_seconds']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Movement in seconds"
                                  label="GPS fix timeout (Movement)"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['packet_retransmit_attempts']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  label="Packet Retransmit attempts"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['lte_scan_trigger_timeout']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Seconds"
                                  label="LTE Scan Trigger Timeout"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['ble_scan_timeout']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Seconds"
                                  label="BLE Scan Timeout"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['ble_scan_trigger_timeout']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Seconds"
                                  label="BLE Scan Trigger Timeout"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['wifi_scan_timeout']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Seconds"
                                  label="Wifi Scan Timeout"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['wifi_scan_trigger_timeout']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Seconds"
                                  label="Wifi Scan Trigger Timeout"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['max_stationary_progress_interval']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  hint="Seconds"
                                  label="Max Stationary Progress Interval"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['ble_scan_interval']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  label="Ble Scan Interval"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['ble_scan_window']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  label="Ble Scan Window"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['movement_instantaneous_fifo_threshold']"
                                  :rules="[vRules.required]"
                                  density="compact"
                                  label="Movement Instantaneous FIFO Threshold"
                                  type="number"/>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-text-field v-model="formData['movement_algo_type']"
                                  density="compact"
                                  label="Movement Algo Type"
                                  type="number"/>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                    <v-switch v-model="formData['ignition_on_ext_gpi1']"
                              color="primary"
                              density="compact"
                              hide-details
                              label="Ignition is on EXT GPI1"/>
                    <p class="text-caption text-medium-emphasis">
                        Orion Fleet only. The tracker watches EXT GPI1 itself, with no External I/O template attached, and reports movement for as long as the line is active.
                    </p>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                    <v-select v-model="formData['ignition_ext_gpi1_active_level']"
                              :disabled="!formData['ignition_on_ext_gpi1']"
                              :items="ignitionActiveLevels"
                              density="compact"
                              item-title="label"
                              item-value="value"
                              label="EXT GPI1 Active State"/>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-card-actions>
                        <v-btn class="px-4" color="primary" type="submit" variant="outlined">Save</v-btn>
                    </v-card-actions>
                </v-col>
            </v-row>
        </v-form>

    </v-container>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const errors = ref([]);
const snackbar = useSnackbarStore();
// Matches the firmware's own encoding so there is one convention rather than two:
// EXT_GPO_ACTIVE_LEVEL_HIGH = 0, EXT_GPO_ACTIVE_LEVEL_LOW = 1. Active high is also
// what the firmware assumes when no External I/O config is present.
const ignitionActiveLevels = [
    {value: 0, label: 'Active High - ignition on when the line is high'},
    {value: 1, label: 'Active Low - ignition on when the line is low'},
];
const formData = reactive({
    valid: false,
    id: null,
    type: 0,
    label: 'Preset General Config',
    gateway_timeout_in_milli_seconds: 5000,
    network_registration_timeout_in_seconds: 120,
    periodic_reboot_status: false,
    periodic_reboot_interval_seconds: 0,
    server_acknowledgment_seconds: 2000,
    network_diagnostics_status: null,
    network_diagnostics_period_seconds: 28800,
    heartbeat_packet_seconds: 10800,
    movement_starts_alert_flag: 29,
    movement_progress_alert_seconds: 30,
    activity_threshold_x_axes: 33,
    activity_threshold_y_axes: 33,
    activity_threshold_z_axes: 33,
    fifo_size: 120,
    seconds_per_sample: 0,
    minimum_activity_interrupts_needed_per_sample: 1,
    fifo_movement_start_thresholds: 5,
    fifo_movement_continue_thresholds: 5,
    gps_minimum_accuracy_idle: 6,
    gps_minimum_accuracy_movement: 25,
    gps_fix_timeout_idle_seconds: 300,
    gps_fix_timeout_movement_seconds: 120,
    packet_retransmit_attempts: 3,
    lte_scan_status: true,
    lte_scan_trigger_timeout: 120,
    ble_scan_status: false,
    ble_scan_timeout: 10,
    ble_scan_trigger_timeout: 30,
    wifi_scan_status: false,
    wifi_scan_timeout: 10,
    wifi_scan_trigger_timeout: 30,
    max_stationary_progress_interval: 300,
    ble_scan_interval: 511,
    ble_scan_window: 48,
    movement_instantaneous_fifo_threshold: null,
    movement_algo_type: null,
    ignition_on_ext_gpi1: false,
    ignition_ext_gpi1_active_level: 0,
});
onMounted(() => {
    getTemplate()
})

const updateMovementFifoThreshold = () => {
    if (!formData['movement_instantaneous_fifo_threshold']) {
        formData['movement_instantaneous_fifo_threshold'] = formData['fifo_movement_start_thresholds'];
    }
}
const getTemplate = () => {
    send('get', `monitoring/preset-general-config`)
        .then((response) => {
            const gcTemplate = response.data.data;
            if (gcTemplate) {
                Object.keys(formData).forEach((key) => {
                    if (gcTemplate[key] !== undefined) {
                        if (['lte_scan_status'
                            , 'ble_scan_status'
                            , 'wifi_scan_status'
                            , 'periodic_reboot_status'
                            , 'ignition_on_ext_gpi1'
                        ].includes(key)) {
                            formData[key] = !!gcTemplate[key];
                        } else {
                            formData[key] = gcTemplate[key];
                        }
                    }
                })
            }
        })
        .catch(function (errorResponse) {
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}
const storeTemplate = () => {
    errors.value = [];
    send(`${formData['id'] ? 'put' : 'post'}`,
        `monitoring/general-templates${formData['id'] ? `/${formData['id']}` : ''}`,
        formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                snackbar.showSnackbar('Record updated successfully');
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response?.data?.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response?.data?.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
